import type { BadgeProperty } from "@/react/types/PaywallCustomization";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { Badge } from "./Badge";

export const Badges = () => {
  const { paywallCustomization } = usePaywallCheckoutContext();

  const { enabled: isBadgeEnabled, badges } =
    paywallCustomization?.badge_properties || {
      enabled: false,
      badges: [],
    };

  if (!isBadgeEnabled) {
    return null;
  }

  return (
    <div className="flex flex-row flex-wrap gap-2">
      {badges.map((badge: BadgeProperty) => (
        <Badge key={badge.id} {...badge} />
      ))}
    </div>
  );
};
